// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"0f87517f","425":"0f87517f","1173":"0f87517f","3003":"991fef34","3143":"f3200482","3830":"0f87517f","4985":"0f87517f","7154":"0f87517f","7959":"bdfd1f51","8033":"0f87517f","8363":"0f87517f","8546":"0f87517f","8641":"0f87517f"}[chunkId] + ".chunk.css";
};